import { throttle } from '@cian/newbuilding-utils';

import { FC, useEffect, useState } from 'react';

import { FixedBlock } from 'shared/components/FixedBlock';
import { HEADER_HIDE_ZONE, STICKY_HEADER_HEIGHT } from 'shared/constants/elements';
import { getCurrentScrollOffset } from 'shared/utils/dom/getCurrentScrollOffset';

import { Header } from '../Header';

export const FixedHeader: FC = () => {
  const [isHeaderFixed, setHeaderFixed] = useState<boolean>(false);

  useEffect(() => {
    const fixHeader = () => {
      const yOffset = getCurrentScrollOffset();

      setHeaderFixed(yOffset > HEADER_HIDE_ZONE);
    };

    const onScrollHandler = throttle(100, fixHeader);

    fixHeader();
    window.addEventListener('scroll', onScrollHandler, false);

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    };
  }, []);

  return (
    <FixedBlock top={isHeaderFixed ? 0 : -STICKY_HEADER_HEIGHT}>
      <Header isFixed={isHeaderFixed} />
    </FixedBlock>
  );
};

FixedHeader.displayName = 'FixedHeader';
